module.exports = __webpack_public_path__ + "static/media/banner4.fd920628.jpg";